// Array of route patterns using regex
const routePatterns = [
  /^\/reports/,
  /^\/email-analytics/,
  /^\/otto-analytics/,
  /^\/daily-checkout-report/,
  /^\/abandoned-calls/,
  /^\/engagements\/dashboard\/media-tracking-details\//,
  /^\/engagements\/dashboard\/message-sent-received-details\//,
];

// Function to check if current path matches any route pattern in the array
export const isReportRouteMatch = path => {
  if (!path) return false;
  // Extract pathname from URL if full URL is passed
  const pathname = path.includes("http") ? new URL(path).pathname : path;

  return routePatterns.some(pattern => pattern.test(pathname));
};

/**
 * Case-insensitive ascending comparator for name columns (lead/customer names).
 * Safe against null/undefined — empty strings sort first.
 */
export const sortByName = (a, b) =>
  String(a ?? "").localeCompare(String(b ?? ""), undefined, { sensitivity: "base" });

export const isAdminRoute = () => {
  const path = window.location.pathname;
  return /^\/admin-dashboard/.test(path);
};
